<template>
    <div class="tb_st03 mt-10 pc-visible">
        <div class="thead">
            <table>
                <caption>리스트헤더</caption>
                <colgroup>
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 60%;">
                </colgroup>
                <thead>
                <tr>
                    <th>구분</th>
                    <th>일자</th>
                    <th>예보</th>
                </tr>
                </thead>
            </table>
        </div>
        <div class="tbody full scroll">
            <table>
                <caption>리스트내용</caption>
                <colgroup>
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 60%;">
                </colgroup>
                <thead style="display: none;">
                <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="air in airForecastList" v-if="typeof nameMap[air.infoCode] !== $_TYPE.UNDEF">
                        <td>{{ nameMap[air.infoCode] }}</td>
                        <td>{{ getDate(air.notiTime) }}</td>
                        <td>{{ air.repOveral }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import gripUtil from "@/libs/grip.util";

export default {
    data(){
        return {
            nameMap: {'PM10': '미세먼지', 'PM25': '초미세먼지', 'O3': '오존'}
        };
    },
    computed: {
        ...mapGetters({
            selectedTopMenu: 'getSelectedTopMenu',
            airForecastList: 'getAirForecastList',
        }),
        topMenuMap() {
            return gripUtil.toDict(this.topMenuList, 'code');
        },
        basdtVal(){
            if(this.airForecastList.length > 0) {
                let basdtVal = gripUtil.extractNumber(this.airForecastList[0].notiTime) + '0000';
                return gripUtil.formatDate(basdtVal, 'yyyy-MM-dd HH:mm') + ' 기준';
            }
            return '';
        },
    },
    methods: {
        getDate(dateStr) {
            dateStr = gripUtil.extractNumber(dateStr) + '0000';
            return gripUtil.formatDate(dateStr, 'MM-dd HH:mm')
        },
    },
};
</script>
